/**
 * Created by valerasiestov on 11.11.15.
 */


 if (!window.module) {
     window.module = {};
 }

 module.fitText = (function () {
     "use strict";

     var controls = {
             list: []
         },
         handlers = {
             apply: function () {
                 var list = controls.list,
                     count = list.length,
                     elementList,
                     elementListCount,
                     i,
                     j;

                 for (i = 0; i < count; i++) {

                     elementList = list[i].element;
                     elementListCount = elementList.length;

                     for (j = 0; j < elementListCount; j++) {
                         if (elementList[j].clientHeight > list[i].size) {
                             elementList[j].classList.add('fit');
                         } else {
                             elementList[j].classList.remove('fit');

                             if (elementList[j].clientHeight > list[i].size) {
                                 elementList[j].classList.add('fit');
                             }
                         }
                     }

                 }
             },
             
             resize: function () {
                 clearTimeout(controls.timeout);
                 controls.timeout = setTimeout(function () {
                     handlers.apply();
                 }, 200);
             }
         };

     function setEventList() {
         window.addEventListener('resize', handlers.resize, false);
     }

     function getControls(selectors) {
         var count = selectors.length,
             i;

         for (i = 0; i < count; i++) {
             controls.list.push({element: document.querySelectorAll(selectors[i].selector), size: selectors[i].size});
         }

         handlers.apply();
     }

     function init(params) {
         getControls(params);
         setEventList();
     }

     return {
         init: init
     };

 }());

 window.addEventListener('DOMContentLoaded', function () {

     module.fitText.init([{selector: '.offers__header', size: 40}]);

 }, false);
